import React from "react";
import SignUpCard from "../Components/Cards/SignUpCard";
import Header from "../Components/Shared/Header";
import Footer from "../Components/Shared/Footer";

function SignUp() {
  return (
    <>
      <div>
        <Header />
        <SignUpCard />
        <Footer />
      </div>
    </>
  );
}

export default SignUp;
